import { MDBBtn, MDBBtnGroup, MDBCol, MDBContainer, MDBListGroup, MDBListGroupItem, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Info.scss";
import Fake from "./../../../assets/images/female/b2.png";
import Fav from "./../../../assets/images/icon/heart.svg";
import Cosmetic from "./../../../assets/images/icon/makeup-pink.svg";
import Hair from "./../../../assets/images/icon/hairstyle-pink.svg";
import Masks from "./../../../assets/images/icon/spa-pink.svg";
import Body from "./../../../assets/images/icon/natural-products-pink.svg";
import Skin from "./../../../assets/images/icon/beauty-waxing-pink.svg";
import Relaxation from "./../../../assets/images/icon/relax-pink.svg";


const Info = (props: InfoProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary
    );

    return <MDBContainer className="info mt-5">
        <MDBRow middle center middle>
            <MDBCol sm="12" md="3">
                <MDBListGroup >
                    <MDBListGroupItem>
                        <h5>{dictionary?.link?.services}</h5>
                    </MDBListGroupItem>
                    <MDBListGroupItem active className="link">
                        <img src={Cosmetic} alt="" className="icon" />
                        {dictionary?.share?.cosmetic_services}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Hair} alt="" className="icon" />
                        {dictionary?.share?.hair_services}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Masks} alt="" className="icon" />
                        {dictionary?.share?.masks}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Body} alt="" className="icon" />
                        {dictionary?.share?.body_services}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Skin} alt="" className="icon" />
                        {dictionary?.share?.skin_services}
                    </MDBListGroupItem>
                    <MDBListGroupItem className="link">
                        <img src={Relaxation} alt="" className="icon" />
                        {dictionary?.share?.relaxation_services}
                    </MDBListGroupItem>
                </MDBListGroup>
            </MDBCol>
            <MDBCol className="info-service" sm="12" md="9">
                <MDBRow middle>
                    <MDBCol className="item" xs="12" sm="6" md="4">
                        <picture>
                            <img src={Fake} />
                        </picture>
                        <p>تركيب الرموش الدائمة</p>
                        <p className="d-block">99 ريال</p>
                        <MDBBtnGroup>
                            <MDBBtn className="waves-effect waves-light">
                                <img src={Fav} />
                            </MDBBtn>
                            <MDBBtn className="waves-effect waves-light">
                                إضافة الي الجلسة
                            </MDBBtn>
                        </MDBBtnGroup>
                    </MDBCol>
                    <MDBCol className="item" xs="12" sm="6" md="4">
                        <picture>
                            <img src={Fake} />
                        </picture>
                        <p>تركيب الرموش الدائمة</p>
                        <p className="d-block">99 ريال</p>
                        <MDBBtnGroup>
                            <MDBBtn className="waves-effect waves-light">
                                <img src={Fav} />
                            </MDBBtn>
                            <MDBBtn className="waves-effect waves-light">
                                إضافة الي الجلسة
                            </MDBBtn>
                        </MDBBtnGroup>
                    </MDBCol>
                    <MDBCol className="item" xs="12" sm="6" md="4">
                        <picture>
                            <img src={Fake} />
                        </picture>
                        <p>تركيب الرموش الدائمة</p>
                        <p className="d-block">99 ريال</p>
                        <MDBBtnGroup>
                            <MDBBtn className="waves-effect waves-light">
                                <img src={Fav} />
                            </MDBBtn>
                            <MDBBtn className="waves-effect waves-light">
                                إضافة الي الجلسة
                            </MDBBtn>
                        </MDBBtnGroup>
                    </MDBCol>
                    <MDBCol className="item" xs="12" sm="6" md="4">
                        <picture>
                            <img src={Fake} />
                        </picture>
                        <p>تركيب الرموش الدائمة</p>
                        <p className="d-block">99 ريال</p>
                        <MDBBtnGroup>
                            <MDBBtn className="waves-effect waves-light">
                                <img src={Fav} />
                            </MDBBtn>
                            <MDBBtn className="waves-effect waves-light">
                                إضافة الي الجلسة
                            </MDBBtn>
                        </MDBBtnGroup>
                    </MDBCol>
                </MDBRow>
            </MDBCol>
        </MDBRow>
    </MDBContainer>
};

interface InfoProps { }
export default Info;